/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { NavLink } from "react-router-dom";
import L from "./Lang"
import BaseCom from "./BaseCom";

export class TabsNavItem extends BaseCom {
    render() {
        return <li className="nav-item" style={{whiteSpace: 'pre', textWrap: 'nowrap'}}><NavLink to={this.props.to} className="nav-link" role="tab" aria-selected="true">{this.props.title} <span className="d-none d-md-inline">{this.props.titleMore}</span></NavLink></li>;
    }
}

export class TabsNav extends BaseCom {
    render() {
        return <>
            <ul className="app-tabs nav nav-tabs">
                {this.props.children}
            </ul>
            <div className="p-4"></div>
        </>;
    }
}